module.exports = __webpack_public_path__ + "static/media/farmindia_img_2.84beec10.png";